module.exports = __webpack_public_path__ + "img/default_footer.c14fab82.png";